<!--动态详情-->
<template>
  <div class="container" v-if="!!info">
    <div class="top-btn-box">
      <img src="@/assets/images/app/logo.png"/>
      <div class="top-logo-box">
        <span>宠源源APP</span>
        <span style="color: #ACADAF;margin-top:2px;">爱宠物更爱自由</span>
      </div>
      <div class="top-open-btn" id="appBtn4">打开看看</div>
    </div>

    <div class="top-bg"></div>

    <div class="main-content">
      <img class="user-avatar" :src="info.user.avatarUrl"/>
      <span class="user-name">{{ info.user.nickName }}</span>
      <span class="time-box">{{ theDate }}</span>
      <div class="words-content" v-if="info.content">{{ info.content }}</div>
      <div class="resource-list" v-if="info.resources.length>0">
        <!--        一个资源的时候展示-->
        <template v-if="info.resources.length==1">
          <div class="single-img-box" v-if="info.resources[0].resourceType==1">
            <img preview="1" :large="info.resources[0].fileUrl" class="single-img" :src="info.resources[0].fileUrl+'!s'"/>
          </div>
          <div class="single-img-box" v-else @click="doPlayVideo" >
<!--            -->
            <img class="single-img" :src="info.resources[0].coverUrl+'!s'"/>
            <img class="play-icon" src="@/assets/images/moment/play_icon.png"/>

<!--            <video-player v-if="isPlayerPopShow"  :playsinline="true"-->
<!--                            id="videoDiv"-->
<!--                            ref="videoPlayer"-->
<!--                            class="my-custom-video-player vjs-custom-skin" :options="playerOptions"-->
<!--                            @close="onClose"-->

<!--                            @play="onPlay"-->
<!--            ></video-player>-->
          </div>
        </template>
        <template v-else>
          <div class="small-img-box" v-for="(item,index) in info.resources" :key="index">
            <img preview="1" :large="item.fileUrl" class="small-img" :src="item.fileUrl+'!s'"/>
          </div>
        </template>

      </div>
      <!--      相关宝贝-->
      <div class="pet-info" v-if="info.type == 2 && info.pets.length>0">
        <div class="pet-name-box"><span class="pet-name">{{ info.pets[0].nickName }}</span></div>
        <div class="pet-desc-box">
          <div class="pet-tags">
            <div class="tag" :class="info['pets'][0]['sex']==1?'tag-boy':(info['pets'][0]['sex']==0?'tag-girl':'')">
              {{ info['pets'][0]['sex'].toString() == "1" ? '弟弟' : (info['pets'][0]['sex'].toString() == "0" ? '妹妹' : '未知') }}
            </div>
            <div class="tag">{{ info['pets'][0]['birthday'] }}</div>
            <div class="tag">{{ info['pets'][0]['breedName'] }}</div>
          </div>
          <div class="words-title"><img class="words-decorate" src="@/assets/images/moment/words_icon.png"/>&nbsp;爱情宣言&nbsp;
            <img class="words-decorate" src="@/assets/images/moment/words_icon.png"/></div>
          <span class="love-word">{{ info.pets[0].loveWord }}</span>
        </div>
      </div>

<!--      地址信息-->
      <div class="address-info-box" v-if="info.address">
      <div class="address-info" ><img src="@/assets/images/moment/location_icon.png"/><span>{{info.address}}</span> </div>
      </div>
<!--     浏览人数等菜单-->
      <div class="footer-menus">
        <div class="menu-item"><img src="@/assets/images/moment/like_icon.png"/><span>{{info.likeNum>0?info.likeNum:'赞'}}</span> </div>
          <div class="menu-item"><img src="@/assets/images/moment/comment_icon.png"/><span>{{info.commentNum>0?info.commentNum:'评论'}}</span> </div>
        <div class="menu-item"><img  src="@/assets/images/moment/hello_icon.png"/><span>打招呼</span> </div>
      </div>

<!--      评论-->
      <div class="comment-container">
        <template v-if="commentList.length>0">
          <div class="comment-title">评论</div>
          <van-list style="padding-bottom: 40px;"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div v-for="(item,index) in commentList" :key="index">
              <div class="comment-parent-box"  :style="{paddingTop:(index==0?'0px':'12px')}" style="display: flex;flex-direction: column;">
                <div class="comment-parent" >
                  <img class="comment-avatar-parent" :src="item.user.avatarUrl"/>

                  <div class="comment-content-row">
                    <div class="comment-content">
                      <div class="comment-user"><span>{{item.user.nickName}}</span> <div class="owner-tag" v-if="info.user.id == item.user.id">作者</div></div>
                      <div class="comment-word"  :class="!(item['status']==1&&item['showStatus']==1)?'disable':''" v-if="item.content">{{item['status'] == 1 && item['showStatus'] == 1
                        ? item['content']
                        : item['status'] == 9
                          ? '该评论已被删除'
                          : '该评论已被屏蔽'}}</div>

                      <!--       带图片         -->
                      <div class="comment-resource-box" v-if="item.imageUrl!='' && item.status == 1 && item.showStatus==1" >
                        <img :preview="item.id" :large="item.imageUrl" class="comment-resource"  :src="item.imageUrl+'!s'"/>
                      </div>

                      <!--                发布时间-->
                      <div class="comment-time">{{commentCreate(item.createTime)}}<span>回复</span></div>

                    </div>
                    <div class="like-box">
                      <img src="@/assets/images/moment/like1_icon.png" />
                      <span v-if="item.likeNum>0">{{item.likeNum}}</span>
                    </div>
                  </div>


                </div>
                <!--                子评论  不展开的情况下 -->
                <div class="reply-list" v-if="item.childList.length>0">

                  <div class="reply-item" v-for="(reply,cindex) in item.childList" :key="cindex" v-if="(!item.isExpand&&cindex<3 || item.isExpand)">
                    <img class="reply-avatar" :src="reply.user.avatarUrl"/>
                    <div class="reply-content">
                      <div class="comment-user reply-user">
                        <span>{{reply.user.nickName}}</span>
                        <div class="owner-tag" v-if="info.user.id == reply.user.id">作者</div>
                        <div style="display: inline-flex;align-items: center" v-if="reply.toUser">
                          <img src="@/assets/images/moment/to_icon.png" />
                          <span style="max-width: 100px;">{{reply.toUser.nickName}}</span>
                        </div>
                      </div>


                      <div class="comment-word reply-word"  :class="!(reply['status']==1&&reply['showStatus']==1)?'disable':''" v-if="reply.content">{{reply['status'] == 1 && reply['showStatus'] == 1
                        ? reply['content']
                        : reply['status'] == 9
                          ? '该评论已被删除'
                          : '该评论已被屏蔽'}}</div>
                      <!--       带图片         -->
                      <div class="comment-resource-box" v-if="reply.imageUrl!='' && reply.status == 1 && item.showStatus==1" >
                        <img :preview="reply.id" :large="reply.imageUrl" class="comment-resource"  :src="reply.imageUrl+'!s'"/>
                      </div>
                      <div class="comment-time">{{commentCreate(reply.createTime)}}<span>回复</span></div>
                    </div>
                    <div class="like-box">
                      <img src="@/assets/images/moment/like1_icon.png" />
                      <span v-if="reply.likeNum>0">{{reply.likeNum}}</span>
                    </div>
                  </div>

                  <div v-if="item.childList.length>3" class="expand-btn" @click="doExpand(index)">{{ !item.isExpand?'展开更多回复':'收起'}}</div>
                </div>
                <div class="split-line" ></div>
              </div>
            </div>

          </van-list>
        </template>

        <div class="empty-container" v-else>
          <img src="@/assets/images/moment/empty.png" />
          <span>暂时没有评论~</span>
        </div>

      </div>
    </div>

    <div class="down-btn" id="appBtn5">
      <div class="down-btn-box">
        <div class="open-box"><img src="@/assets/images/share/open_icon.png"/><span>宠 源 源</span>
        </div>
        <div style="height: 32px;line-height: 32px;">APP内打开</div>

      </div>

    </div>

    <van-popup v-model="isPlayerPopShow"  >
      <div class="pop-container">
        <img src="@/assets/images/moment/back_icon.png" class="close-btn" @click="isPlayerPopShow=false"/>
        <div id="dplayer" style="width: 100vw;">
          <d-player ref="player" :options="dPlayerOptions"></d-player>
        </div>

      </div>

    </van-popup>
    <!--    <div ref="richContent" v-html="info.content"></div>-->

<!--    <div id="appBtn1" style="position: fixed; top:0; z-index: 99;margin:20px 0 0 50%;">Xinstall APP中打开</div>-->
<!--    <div id="appBtn2" @click="doOpenApp" style="position: fixed; top:0; z-index: 99;margin:100px 0 0 50%;">OpenInstall APP中</div>-->


  </div>
</template>


<script>

import VueDPlayer from 'vue-dplayer'
import 'vue-dplayer/dist/vue-dplayer.css'
// import 'video.js/dist/video-js.css'

import {formatDate} from "@/utils/common";
import {getMomentInfo, getMommentCommentList} from "@/axios/moment";
import {Toast} from "vant";

export default {
  components: {
    VueDPlayer
  },

  data() {
    return {
      isPlayerPopShow: false,
      info: null,
      loading: false,
      finished:false,
      commentList:[],
      page:1,

    };
  },
  activated() {
    //  48  有视频
    // 44 有多张图
    // 47 有评论  133

    // this.loadData(133);
    this.loadData(this.$route.query.id);
  },

  mounted:function(){
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = '//cdn.xinstall.com/xinstall.js';
    s.addEventListener('load',()=>{
      var data = XInstall.parseUrlParams();

      new XInstall({
        /*xinstall中应用的唯一标识，用于识别您的应用*/
        appKey : "6h1edzo",

        buttonId: [
          { idName: 'appBtn4', params: data },
          { idName: 'appBtn5', params: data },
        ],

        /*—————————————————分割线——————————————————*/
        /*附加功能1：特殊情况无法直接跳转下载时，引导打开三方浏览器下载的遮罩层可用以下方法自定义样式*/
        //mask:function(){
        //  return "<div style='background:rgba(0,0,0,.5);position:fixed;left:0;top:0;filter:alpha(opacity=50);width:100%;height:100%;z-index:9999;'><div style='text-align:right; margin-top:1%; margin-right:5%;'><img style='width:70%; margin:0 auto;' src='https://cdn.xinstall.com/image/no_safari.png'/></div></div>"
        //},
        /*—————————————————分割线——————————————————*/
      }, data);
    },false);
    document.head.appendChild(s);
  },


  watch: {},


  computed: {
    theDate() {
      return formatDate(
        new Date(this.info.createTime),
        "yyyy/MM/dd HH:mm:ss"
      );
    },

    dPlayerOptions() {
     var options = {
       autoplay:false,
       container: document.getElementById("dplayer"),
       video: {
         url: this.info.resources.length==1 && this.info.resources[0].resourceType!=1?this.info.resources[0].fileUrl:'',
         pic: this.info.resources.length==1 && this.info.resources[0].resourceType!=1?this.info.resources[0].coverUrl:''
       }
     }
     return options
    },
  },

  methods: {
    commentCreate(value) {
      return formatDate(
        new Date(value),
        "yyyy/MM/dd HH:mm:ss"
      );
    },

    doExpand(pindex) {
      console.log(pindex)
      debugger
      var oldValue = this.commentList[pindex]
      oldValue.isExpand = !oldValue.isExpand;

      this.$set(this.commentList, pindex, oldValue);
    },

    loadData(key) {
      getMomentInfo({'id': key}).then((res) => {
        if(res.code == 0) {
          this.info = res.data;
          document.title = "动态详情";
          this.$previewRefresh()
          this.loadCommentData();
        } else {
          Toast(res.message)
        }

      });
    },

    loadCommentData() {
      getMommentCommentList({'objectId': this.info.id,'objectType':1,'page':this.page, 'pageSize':20}).then((res) => {
        if(this.page == 1) {
          this.commentList = res.data.list;
        } else {
          this.commentList = [...this.commentList, ...res.data.list]; // 上一页数据跟新加载的数据做合并
          // 判断数据是否加载完毕
          // if (res.data.list.length < 20) {
            // 将finished设置为true,表示所有数据加载完毕
            // this.finished = true;
          // }

          this.finished = this.commentList.length>=res.data.total
        }

        this.loading = false;
      });
    },

    onLoad() {
      // 开始异步请求数据
      // this.loading = true;
      this.page++;
      // 本次数据更新成功后，将loading设置为false
      this.loadCommentData();
    },

    doPlayVideo() {
      this.isPlayerPopShow = true
      this.$nextTick(() => {
        this.$refs.player.dp.play()
      })
    },

    // doOpenApp() {
    //   var data = OpenInstall.parseUrlParams();///openinstall.js中提供的api，解析当前网页url中的查询参数并对data进行赋值
    //   new OpenInstall({//初始化方法，与openinstall服务器交互，应尽早调用
    //     appKey : "hradio",//appKey为openinstall为应用分配的唯一id（必须传入）
    //     onready : function() {//初始化成功回调方法。当初始化完成后，会自动进入
    //       this.schemeWakeup();//尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
    //       var m = this
    //        var button = document.getElementById("appBtn2");//为button对象绑定对应id的元素
    //       button.onclick = function() {//对应button的点击事件
    //         m.wakeupOrInstall();//此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
    //         return false;
    //       }
    //     }
    //   }, data);//初始化时传入data，作为一键拉起/App传参安装时候的参数
    // }
  }
};




// (function () {
//   var data = OpenInstall.parseUrlParams();///openinstall.js中提供的api，解析当前网页url中的查询参数并对data进行赋值
//   new OpenInstall({//初始化方法，与openinstall服务器交互，应尽早调用
//     appKey : "hradio",//appKey为openinstall为应用分配的唯一id（必须传入）
//     onready : function() {//初始化成功回调方法。当初始化完成后，会自动进入
//       this.schemeWakeup();//尝试使用scheme打开App（主要用于Android以及iOS的QQ环境中）
//       var m = this
//       //     button = document.getElementById("appBtn2");//为button对象绑定对应id的元素
//       // button.onclick = function() {//对应button的点击事件
//       //   m.wakeupOrInstall();//此方法为scheme、Universal Link唤醒以及引导下载的作用（必须调用且不可额外自行跳转下载）
//       //   return false;
//       // }
//     }
//   }, data);//初始化时传入data，作为一键拉起/App传参安装时候的参数
// })();

</script>

<style lang='less' scoped>
.pop-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: inline-flex;
  align-items: center;
  background-color: #303030;
}

.close-btn {
  position: absolute;
  top:0px;
  left: 24px;
  width: 40px;
  height: 40px;
  z-index: 9;
}

.container {

  width: 100%;
  //width: calc(100% - 32px);
  //margin: 16px 16px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #190a02;
  font-family: -apple-system;
}

.top-bg {
  width: 100%;
  background-color: #FFE10F;
  height: 160px;
}

.main-content {
  margin-top: -40px;
  padding: 0px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 20px 20px 0 0;
}

.user-avatar {
  width: 80px;
  height: 80px;
  margin-top: -40px;
  border-radius: 50%;
}

.user-name {
  font-weight: 600;
  font-size: 20px;
  color: #0D0D0D;
  max-width: 80%;
  margin-top: 12px;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证文本在一行内显示，不换行 */
  overflow: hidden; /* 超出容器部分隐藏 */
}

.time-box {
  margin-top: 8px;
  font-size: 12px;
  color: #ACADAF;
}

.words-content {
  width: 100%;
  text-align: left;
  font-size: 16px;
  color: #0D0D0D;
  margin-top: 20px;
}

.resource-list {
  margin-top: 8px;
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
}

.single-img-box {
  display: inline-flex;
  position: relative;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
}

.single-img {
  border-radius: 12px;
  max-width: 220px;
  max-height: 220px;
  object-fit: contain;
}

.play-icon {
  position: absolute;
  width: 40px;
  height: 40px;
}

.resource-list .small-img-box:nth-child(3n+3) {
  margin-right: 0px;
}

.small-img-box {
  margin-right: 6px;
  width: calc((100%  - 12px) / 3);
  aspect-ratio: 1;
  margin-bottom: 6px;
}

.small-img-box img {
  border-radius: 12px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pet-info {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  border-radius: 18px 18px 20px 20px;
  border: 1px solid #EEEEEE;
  width: 100%;

  .pet-name-box {
    border-radius: 16px 16px 0px 0px;
    height: 32px;
    background: #FFE10F;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .pet-name {
      font-size: 16px;
      color: #0D0D0D;
      font-weight: bold;
      text-overflow: ellipsis;
      white-space: nowrap; /* 保证文本在一行内显示，不换行 */
      overflow: hidden; /* 超出容器部分隐藏 */

    }
  }

  .pet-desc-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #FCFCFC;
    padding: 16px 16px 20px 16px;
    border-radius: 0px 20px;
  }

  .pet-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .tag {
    padding: 0px 10px;
    height: 20px;
    margin-right: 20px;
    background: #EEE;
    border-radius: 20px;
    font-size: 12px;
    color: #0D0D0D;
    line-height: 20px;
  }

  .tag-girl {
    background: #FF66E2;
    color: white;
  }

  .tag-boy {
    background: #2CBCF4;
    color: white;
  }

  .words-title {
    margin-top: 24px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    color: #E72A36;
  }

  .words-decorate {
    width: 12px;
    height: 12px;
  }

  .love-word {
    font-size: 16px;
    color: #0D0D0D;
    margin-top: 8px;
    text-align: center;
    font-weight: 500;
    white-space: break-spaces;
  }

}


.footer-menus {
  margin-top: 16px;
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 25px;
  border-bottom: 1px solid #EEEEEE;
}

.menu-item {
  margin-left: 20px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #ACADAF;
}

.menu-item img {
  width: 17px;
  height: 17px;
  margin-right: 4px;
}

//.video-player {
//  top: 0;
//  left: 0;
//  bottom: 0;
//  width: 100%;
//  height: 100%;
//  position: absolute;
//}

.comment-container {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.comment-title {
  width: 48px;
  height: 24px;
  background: #EEEEEE;
  border-radius: 20px;
  font-size: 12px;
  color: #0D0D0D;
  line-height: 24px;
  text-align: center;
  margin-bottom: 16px;
}

.empty-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 40px 0px 180px 0px;
}

.empty-container img {
  width: 200px;
  height: 200px;
}

.empty-container span {
  margin-top: 16px;
  font-size: 14px;
  color: #A2A3A5;
}

.comment-parent {
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.comment-avatar-parent {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
}

.comment-content-row {
  display: inline-flex;
  align-items: flex-start;
  flex:1;
  justify-content: flex-start;
}

.comment-content {
  display: flex;
  flex-direction: column;
  flex:1;

}

.like-box {

  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #ACADAF;
  align-items: center;
}

.like-box img {
  width: 15px;
  height: 13px;
  margin-bottom: 4px;
}

.comment-user {
  font-size: 14px;
  color: #ACADAF;
  display: inline-flex;
  align-items: center;

}

.owner-tag {
  width: 36px;
  height: 16px;
  background: #F6F6F6;
  border-radius: 20px;
  font-size: 10px;
  color: #ACADAF;
  line-height: 16px;
  text-align: center;
  margin-left: 4px;
}

.comment-user span {
  max-width: 200px;
  max-lines: 1;
  text-overflow: ellipsis;
  white-space: nowrap; /* 保证文本在一行内显示，不换行 */
  overflow: hidden; /* 超出容器部分隐藏 */
}


.reply-user img {
  width: 8px;
  height: 8px;
  margin:0px 4px;
}
.comment-word {
  font-size: 14px;
  color: #0D0D0D;
  line-height: 20px;
  margin-top: 8px;
}

.disable {
  color: #A2A3A5;
}

.comment-resource-box {
  margin-top:8px;
}

.comment-resource {
  max-width: 120px;
  max-height: 120px;
  border-radius: 12px;
  object-fit: contain;
}

.comment-time {
  font-size: 12px;
  color: #A2A3A5;
  margin-top: 8px;
}

.comment-time span {
  font-weight: 600;
  font-size: 12px;
  color: #A2A3A5;
  margin-left: 12px;
}


.reply-content {
  flex:1;
}

.reply-list {
  //margin-top:12px;
  margin-left: 52px;
}

.split-line {
  padding-top:12px;
  border-bottom: 1px solid #EEEEEE;
  margin-left: 52px;
}

.reply-item {
  width: 100%;
  display: inline-flex;
  margin-top: 12px;
}

.reply-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right:12px;
}

.expand-btn {
  font-weight: 600;
  font-size: 14px;
  color: #46BCB0;
  margin-left: 44px;
  margin-top: 12px;
}

.address-info-box {
  margin-top: 8px;
  display: inline-flex;
  width: 100%;
  justify-content: flex-start;
}

.address-info {
  padding: 0px 8px;
  height: 18px;
  border-radius: 18px;
  display: inline-flex;
  font-size: 10px;
  color: #ACADAF;
  align-items: center;
  border: 1px solid #DDDDDD;
}

.address-info img {
  width: 7px;
  height: 7px;
  margin-right: 4px;
}


//自定义播放器样式
.my-custom-video-player {
  /* 自定义视频播放器的外观属性 */
  background-color: #000;
  color: #fff;
}

/* 覆盖默认播放器按钮样式 */
.my-custom-video-player .vjs-play-button {

  //background: url('~@/assets/images/moment/play_icon.png') no-repeat;
  background-image: url('../../assets/images/moment/play_icon.png') !important;
}


.top-btn-box {
  width: calc(100% - 48px);

  padding:12px 24px;
  font-weight: 600;
  align-items: center;
  display: inline-flex;
  font-size: 16px;
  color: #0D0D0D;
}

.top-open-btn {
  height: 24px;
  background-color: #FFE10F;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  padding:0px 8px;
  border-radius: 12px;
  font-weight: 500;
  color: #0D0D0D;
}

.top-logo-box {
  flex:1;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #0D0D0D;
  font-weight: normal;
}

.top-btn-box img {
  width: 32px;
  height: 32px;
  margin-right: 13px;
}


.down-btn {
  background-image: url('../../assets/images/share/footer_bg.png');
  background-repeat: no-repeat;
  background-size: 227px 75px;
  color: #0D0D0D;
  height: 75px;
  width: 227px;
  font-size: 16px;
  text-align: center;
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  position: fixed;
  bottom:40px;
  left:calc(50% - 113px);
}

.down-btn-box {
  padding-top: 25px;
  display: inline-flex;
}

.open-box {
  width: 103px;
  height: 32px;
  background: #FFFFFF;
  border-radius: 26px;
  font-weight: 600;
  font-size: 16px;
  color: #0D0D0D;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.open-box img {
  width: 20px;
  height: 13px;
  margin-right: 8px;
}

</style>
